import { service } from '../../../../helpers/http'

export const ActionIndexOccurrenceSheetMotives = ({ dispatch }, payload) => {

    return service({
        module: 'timeSheet',
        action: 'indexOccurrenceSheetMotives',
        payload: payload
    })
    
}

export const ActionCreateOccurrenceSheetMotive = ({ dispatch }, payload) => {
    
    return service({
        module: 'timeSheet',
        action: 'createOccurrenceSheetMotive',
        payload: payload
    })
    
}

export const ActionUpdateOccurrenceSheetMotive = ({ dispatch }, payload) => {
    
    return service({
        module: 'timeSheet',
        action: 'updateOccurrenceSheetMotive',
        payload: payload
    })
}

export const ActionDestroyOccurrenceSheetMotive = ({ dispatch }, payload) => {
    
    return service({
        module: 'timeSheet',
        action: 'destroyOccurrenceSheetMotive',
        payload: payload
    })
    
}

export const ActionFindOccurrenceStatus = ({ dispatch }, payload) => {

    return service({
        module: 'timeSheet',
        action: 'findStatusOccurrenceType',
        payload: payload
    })
    
}

export const ActionFindOccurrenceNatures = ({ dispatch }, payload) => {

    return service({
        module: 'timeSheet',
        action: 'findNaturesOccurrenceType',
        payload: payload
    })
    
}

